import { createApp } from '@app/adapters/create-app'
import SfAssistantChecksPage from '@app/application/sf-assistant-checks/components/sf-assistant-checks-page.vue'

window.onDomLoad(function ($doc) {
  const element = $doc[0].querySelector(
    '[data-behaviour="sf-assistant-checks-page"]'
  ) as HTMLElement

  if (element) {
    const { workflow: contextId } = element.dataset ?? {}

    createApp(
      SfAssistantChecksPage,
      { contextId },
      { singletonId: 'sf-assistant-checks-page' }
    ).mount(element)
  }
})
